<template>
  <div class="copyright-form-container">
    <el-form
      ref="ruleFormRef"
      :model="configDataForm"
      :rules="rules"
      label-width="100px"
      :size="formSize"
    >
      <div class="card-frame other-card-frame">
        <div class="card-frame-top">基础设置</div>
        <div class="card-frame-container">
          <el-form-item label="文案颜色：" prop="fontColor">
            <el-color-picker v-model="configDataForm.fontColor" />
          </el-form-item>
          <el-form-item label="右侧背景色：" prop="backgroundColor">
            <el-color-picker v-model="configDataForm.backgroundColor" />
          </el-form-item>
        </div>
      </div>
      <div class="card-frame other-card-frame">
        <div class="card-frame-top">内容项</div>
        <div class="card-frame-container">
          <el-alert type="info" show-icon :closable="false">
            <p class="font-size-12">
              说明：提示：版权区展示内容顺序可通过调整每项文案和链接进行自由组合
            </p>
          </el-alert>
          <el-row
            v-for="(item, index) in configDataForm.items"
            :key="item"
            class="el-row-customer"
          >
            <span class="copyright-form-item-form">
              <el-col :span="24">
                <el-form-item
                  label="类型："
                  :prop="`items[${index}].type`"
                  :rules="rules.type"
                >
                  <zc-select
                    v-model="item.type"
                    style="width: 600px"
                    placeholder="选择类型"
                    :data="typeList"
                  ></zc-select>
                </el-form-item>
              </el-col>
              <el-col v-if="item.type === 1" :span="24">
                <el-form-item
                  :label="'文案' + item.sortNum + '：'"
                  :prop="`items[${index}].text`"
                  :rules="rules.text"
                >
                  <el-input
                    v-model="item.text"
                    style="width: 600px !important"
                  />
                </el-form-item>
                <el-form-item
                  label="跳转链接："
                  :prop="`items[${index}].linkUrl`"
                  :rules="rules.linkUrl"
                >
                  <el-input
                    v-model="item.linkUrl"
                    style="width: 600px !important"
                  />
                </el-form-item>
              </el-col>
              <el-col v-else :span="24">
                <el-form-item
                  label="图标："
                  :prop="`items[${index}].iconNameObj`"
                  :rules="rules.iconNameObj"
                >
                  <zc-upload
                    v-model="item.iconNameObj"
                    :limit-single-size="1048576"
                    type="singleImage"
                    :enable-popup="false"
                    :show-no-image="true"
                    :small-text="true"
                    tip="说明：上传的图片大小不得超过100KB，建议尺寸40*40px"
                    @change="handleChange(index)"
                  >
                    <template #singleImageError>
                      <div class="el-image__error image-error-show">
                        图片丢失
                      </div>
                    </template>
                  </zc-upload>
                </el-form-item>
              </el-col>
            </span>
            <span class="copyright-form-item-remove">
              <template v-if="configDataForm.items.length > 1">
                <el-link type="danger" @click="handleDel(index)">
                  移除
                </el-link>
              </template>
              <template v-else>
                <el-tooltip content="至少保留一项版权内容项" placement="top">
                  <el-link type="danger" disabled> 移除 </el-link>
                </el-tooltip>
              </template>
            </span>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-button style="width: 100%" @click="handleAddItem()"
                ><el-icon><Plus /></el-icon>添加项</el-button
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="copyright-btn-container">
      <el-button @click="handleCancel()">取消</el-button>
      <el-button type="primary" @click="handleSave(ruleFormRef)"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script setup>
// #region 引用
import {
  verifyCharacterLength,
  verifyLinkUrl,
} from '@/utils/common/form-verify-util';
import { Plus } from '@element-plus/icons-vue';

// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  componentData: {
    type: Object,
    default() {},
  },
});
/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'update:modelValue',
  'handle-edit-components-content',
]);

// #endregion

// #region 变量/常量

// 栏目数据列表
const typeList = ref([
  { value: 1, label: '文本' },
  { value: 2, label: '图标' },
]);

// 表单size
const formSize = ref('default');
const ruleFormRef = ref();
// 表单绑定对象
const configDataForm = ref({
  items: [
    {
      sortNum: 1,
      type: 1,
      text: '版权所有：成都众创益优科技有限公司',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon1',
      iconNameObj: null,
    },
    {
      sortNum: 3,
      type: 1,
      text: '©2015',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon3',
      iconNameObj: null,
    },
    {
      sortNum: 4,
      type: 1,
      text: '蜀ICP备19003160号',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon4',
      iconNameObj: null,
    },
    {
      sortNum: 2,
      type: 2,
      text: '',
      linkUrl: '',
      iconName: '/src/views/components/website/footer/image/beian.png',
      iconFileKey: 'icon2',
      iconNameObj: null,
    },
    {
      sortNum: 5,
      type: 1,
      text: '川公网安备 51010702001419号',
      linkUrl: 'https://www.baidu.com',
      iconName: '',
      iconFileKey: 'icon5',
      iconNameObj: null,
    },
  ],
  backgroundColor: '#000000',
  fontColor: '#ffffff',
});

configDataForm.value.items.sort((a, b) => {
  return a.sortNum - b.sortNum;
});

if (props.componentData.configData) {
  configDataForm.value = JSON.parse(props.componentData.configData);

  configDataForm.value.items = configDataForm.value.items.map((f) => ({
    ...f,
    iconNameObj: {
      name: f.iconName,
      url: f.iconFullUrl,
    },
  }));

  configDataForm.value.items.sort((a, b) => {
    return a.sortNum - b.sortNum;
  });
}

// 表单规则
const rules = ref({
  backgroundColor: [{ required: true, message: '必填项', trigger: 'blur' }],
  fontColor: [{ required: true, message: '必填项', trigger: 'blur' }],
  type: [{ required: true, message: '必填项', trigger: 'blur' }],
  text: [
    { required: true, message: '必填项', trigger: 'blur' },
    { validator: verifyCharacterLength, clen: 200, trigger: 'blur' },
  ],
  iconNameObj: [{ required: true, message: '必填项', trigger: 'blur' }],
  linkUrl: [{ validator: verifyLinkUrl, clen: 500, trigger: 'blur' }],
});
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 图片改变后调用
 */
const handleChange = (index) => {
  // console.log('index:', index);
  ruleFormRef.value.validateField(`items[${index}].iconNameObj`, (valid) => {});
};

/**
 * 处理取消
 */
const handleCancel = () => {
  emits('handle-show-edit-form', false);
};
/**
 * 处理保存
 */
const handleSave = (form) => {
  if (!form) return;

  form.validate((valid, fields) => {
    if (valid) {
      // console.log('configDataForm-CopyrightEditForm:', configDataForm.value);

      // 待数据更新完成后才执行
      nextTick(() => {
        emits('handle-edit-components-content', false);
        emits('update:modelValue', configDataForm.value);
      });
      // TODO 待完成保存逻辑
    }
  });
};

/**
 * 处理删除
 */
const handleDel = (index) => {
  configDataForm.value.items.splice(index, 1);
  //   handleResetRules();
};

/**
 * 添加项目
 */
const handleAddItem = () => {
  // 获取当前最大排序号

  const sortNumArr = configDataForm.value.items.map((f) => {
    return f.sortNum;
  });

  const sortNum = Math.max(...sortNumArr) + 1;

  configDataForm.value.items.push({
    sortNum,
    type: 1,
    text: '',
    linkUrl: '',
    iconName: '',
    iconFileKey: `icon${sortNum}`,
    iconNameObj: null,
  });
};

// #endregion
</script>

<style scoped lang="scss">
.copyright-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  margin: auto;
  cursor: pointer;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.copyright-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  background: var(--el-color-white);
}

.copyright-btn-container button {
  margin: 8px;
}

:deep(.el-color-picker__trigger) {
  width: 100px;
}

:deep(.el-form) {
  width: 100%;
  padding: 20px;
}

.card-frame {
  margin-bottom: unset !important;
}

.el-row-customer {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  padding-top: 10px;
  margin: 10px 0;
  border: 1px solid;
  border-color: var(--el-color-grey-light-45);

  /* flex-direction: column; */
}

.copyright-form-item-form {
  width: calc(100% - 44px) !important;
}

.copyright-form-item-remove {
  width: 24px !important;
  margin: 0 5px;
}
</style>
